// eslint-disable-next-line import/no-internal-modules
import { css } from 'aphrodite';
import * as React from 'react';
import { useState } from 'react';
import ReactDOM from 'react-dom';
import { Button } from '../../../../web/components/Button';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';
import CoffeeAnimationImageUrl from '../../../assets/coffee-animation.gif';
import TysonSplashImageUrl from '../../../assets/tyson-splash.jpg';
import { useTysonMode } from '../../../contexts/tysonMode';
import { CoffeeLogo } from '../../svgs/CoffeeLogo';
import { styleSheet } from '../styles';

interface IProps {
	onClick: () => void;
}

export const SplashScreen: React.FC<IProps> = ({ onClick }) => {
	const [loading, setLoading] = useState(false);
	const { isActive: isTysonModeActive } = useTysonMode();

	const letsGoClick = (e: React.MouseEvent<HTMLElement>) => {
		setLoading(true);
		e.stopPropagation();
		onClick();
	};

	const component = (
		<div>
			{!isTysonModeActive && (
				<div className={`${css(styleSheet.headerContainer)}`}>
					<CoffeeLogo className={css(styleSheet.splashScreenLogo)} />
				</div>
			)}
			<div className={css(styleSheet.splashScreen)} onClick={letsGoClick}>
				<img
					className={css(styleSheet.splashScreenImage)}
					src={isTysonModeActive ? TysonSplashImageUrl : CoffeeAnimationImageUrl}
				/>
				<div className={isTysonModeActive ? css(styleSheet.splashScreenButtonContainer) : undefined}>
					{loading ? <LoadingSpinner type='small' /> : <Button onClick={letsGoClick} label="Let's go!" />}
				</div>
			</div>
		</div>
	);
	const nodeToAppend = document.querySelector('body');

	return ReactDOM.createPortal(component, nodeToAppend);
};
